<div class="w-100 d-flex flex-wrap surface-elevated h-100">
  <ngx-app-bar
    class="w-100"
    [title]="'بررسی اعتبار'"
    [rightButton]="{
      icon: 'arrow-right',
      style: 'neutral-link',
      mode: 'icon-only',
      size: 'medium',
    }"
    (onRightButtonClick)="onBackHandler()"
  />

  <div class="w-100 d-flex flex-wrap align-items-center justify-content-center px-plus content-container">
    <img
      [src]="
        state()?.cancelResutl?.status === ECreditStatus.Failed
          ? './wealth-assets/svg/failed-credit-icon.svg'
          : './wealth-assets/svg/check-credit-icon.svg'
      "
      alt=""
    />

    <div class="w-100 text-align-center mt-big">
      <p class="st-7 text-onback-high">
        @if (state()?.cancelResutl?.status === ECreditStatus.InClosure) {
          در حال بررسی لغو اعتبار شما هستیم...
        } @else if (state()?.cancelResutl?.status === ECreditStatus.Failed) {
          امکان لغو اعتبار شما وجود ندارد
        } @else {
          در حال بررسی امکان دریافت اعتبار برای شما هستیم
        }
      </p>
    </div>

    <div class="w-100 text-align-center mt-small">
      <p class="bt-2 text-onback-medium">
        @if (state().cancelResutl) {
          {{ state().cancelResutl.message }}
        } @else {
          @if (state()?.cancelResutl?.status === ECreditStatus.InClosure) {
            حداکثر تا ۱ روز آینده می‌توانید وضعیت لغو اعتبار خود را در قسمت جزئیات اعتبار مشاهده کنید.
          } @else {
            بعد از ۱ روز کاری، می‌توانید وضعیت اعتبار خود را در کیف ثروت مشاهده کنید. تا پایان بررسی، موجودی شما غیر قابل برداشت خواهد بود.
          }
        }
      </p>
    </div>

    @if (!state().cancelResutl) {
      <div class="w-100 mt-big">
        <wealth-applet-bnpl-banner
          class="d-flex"
          [bnplTitle]="state()?.amount + 'ریال اعتبار 4 قسطه'"
          [bnplDescription]="'بازپرداخت هر قسط: ' + state()?.repaymentDate"
        />
      </div>
    }
  </div>

  <div class="w-100 cashin-buttons px-plus">
    <ngx-button
      [buttonId]="'WALLET_BNPL_DETAIL_CONFIRM'"
      [style]="'fill'"
      [fullWidth]="true"
      [mode]="'form'"
      size="medium"
      (clickHandler)="onBackHandler()"
    >
      متوجه شدم
    </ngx-button>
  </div>
</div>
